'use client'
import { useEffect, useState } from 'react'

// Same storage keys as the mockup kit (kit.js), so the pages and the mockups agree.
const LS_THEME = 'sj-estv4-theme'
const LS_PAL = 'sj-estv4-palette'

function apply(theme: string, palette: string) {
  const root = document.documentElement
  root.classList.toggle('dark', theme === 'dark')
  if (palette === 'teal') root.setAttribute('data-palette', 'teal')
  else root.removeAttribute('data-palette')
}

export function ThemeToggle() {
  const [theme, setTheme] = useState('light')
  const [palette, setPalette] = useState('brass')
  useEffect(() => {
    const t = localStorage.getItem(LS_THEME) === 'dark' ? 'dark' : 'light'
    const p = localStorage.getItem(LS_PAL) === 'teal' ? 'teal' : 'brass'
    setTheme(t)
    setPalette(p)
    apply(t, p)
  }, [])
  const flipTheme = () => {
    const t = theme === 'dark' ? 'light' : 'dark'
    localStorage.setItem(LS_THEME, t)
    setTheme(t)
    apply(t, palette)
  }
  const flipPalette = () => {
    const p = palette === 'teal' ? 'brass' : 'teal'
    localStorage.setItem(LS_PAL, p)
    setPalette(p)
    apply(theme, p)
  }
  return (
    <div className="flex gap-2">
      <button type="button" className="btn" onClick={flipTheme} data-testid="lab-theme">
        {theme === 'dark' ? 'Light' : 'Dark'}
      </button>
      <button type="button" className="btn" onClick={flipPalette} data-testid="lab-palette">
        {palette === 'teal' ? 'Brass' : 'Teal'}
      </button>
    </div>
  )
}
